import { render, staticRenderFns } from "./players-pv.vue?vue&type=template&id=00e24828&"
import script from "./players-pv.vue?vue&type=script&lang=js&"
export * from "./players-pv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports